<template>
  <div id="warning">
    <!-- Warning about percentage -->
    <div v-if="calcAreaPctTotal != 100" class="alert alert-warning mt-2" role="alert">
      Area fields must add up to 100%. They currently add up to {{ calcAreaPctTotal }}%!
    </div><!-- /.alert -->
  </div><!-- /#percentageWarning -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['calcAreaPctTotal'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Warning.vue